import axios from "axios";

import { setToast } from "../../util/toast";
import * as ActionType from "./user.type";
import { apiInstanceFetch } from "../../util/api";

export const getUser = (start,limit) => (dispatch) => {
  apiInstanceFetch
    .get(`user/userGet?start=${start}&limit=${limit}`)
    .then((res) => {
      
      dispatch({
        type: ActionType.GET_USER,
        payload: {userAll: res.userAll,total: res.userCount},
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

// get profile

export const getUserProfile = (id) => (dispatch) => {
  apiInstanceFetch
    .get(`user/userProfileByadmin?id=${id}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_USER_PROFILE,
        payload: res.findUser,
      });
    })
    .catch((error) => {
      console.log(error);
      setToast("error", error.message);
    });
};

export const blockUser = (user, reason, hours) => (dispatch) => {
  axios
    .patch(`user/isBlock?userId=${user._id}`, { reason: reason || "", hours: hours || 0 })
    .then((res) => {
      // sunucu reddettiyse (sebep yok vb.) "basarili" deme
      if (res?.data?.status === false) return setToast("error", res.data.message || "İşlem başarısız");
      dispatch({
        type: ActionType.GET_USER_BLOCK,
        payload: { data: res.data.user, id: user._id },
      });
      setToast(
        "success",
        `${user.name} ${user.isBlock !== true ? "engellendi" : "engeli kaldırıldı"}`
      );
    })
    .catch((error) => {
      console.log(error);
      setToast("error", error.message);
    });
};
// get history

export const getUserHistory =
  (userId, startDate, endDate, page, size, type) => (dispatch) => {
    apiInstanceFetch
      .get(
        `history/historyForUser?userId=${userId}&type=${type}&start=${page}&limit=${size}&startDate=${startDate}&endDate=${endDate}`
      )
      .then((res) => {
        dispatch({
          type: ActionType.GET_USER_HISTORY,
          payload: res,
        });
      })
      .catch((err) => console.log(err));
  };

// user coin update
export const updateHostCoin = (val, ids) => (dispatch) => {
  axios
    .post(`user/addLessCoin`, { userId: ids, coin: val })
    .then((res) => {
      console.log(res.data);
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_USER_COIN,
          payload: { editHostCoin: res.data.hostExist },
        });
        setToast("success", "User Updated Successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error));
};

/// Panelden kullanici alanlarini gunceller (ozel ID dahil).
export const updateUserByAdmin = (userId, fields) => (dispatch) => {
  axios
    .patch(`user/updateByAdmin`, { userId, ...fields })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_USER_BY_ADMIN,
          payload: res.data.user,
        });
        setToast("success", res.data.message || "Kullanıcı güncellendi");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error?.response?.data?.message || "Güncellenemedi"));
};

// "6" = 6 saat, "3g" = 3 gun, bos = kalici; iptalde null
export const sureSor = () => {
  const c = window.prompt("Engel süresi: saat için 6, gün için 3g yaz. Boş bırakırsan kalıcı olur.", "");
  if (c === null) return null;
  const m = /^\s*(\d+(?:[.,]\d+)?)\s*(g|gün|gun|s|saat)?\s*$/i.exec(c);
  if (!c.trim()) return 0;
  if (!m) {
    window.alert("Süre anlaşılamadı. Örnek: 6 veya 3g");
    return null;
  }
  const n = Number(m[1].replace(",", "."));
  return /^g/i.test(m[2] || "") ? n * 24 : n;
};
